import { render, staticRenderFns } from "./BrbBtn.vue?vue&type=template&id=58d2700e&"
import script from "./BrbBtn.vue?vue&type=script&lang=js&"
export * from "./BrbBtn.vue?vue&type=script&lang=js&"
import style0 from "./BrbBtn.vue?vue&type=style&index=0&id=58d2700e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d2700e')) {
      api.createRecord('58d2700e', component.options)
    } else {
      api.reload('58d2700e', component.options)
    }
    module.hot.accept("./BrbBtn.vue?vue&type=template&id=58d2700e&", function () {
      api.rerender('58d2700e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbBtn.vue"
export default component.exports